var indexFeature = {
  "fields": {
    "id": {
      "name": "id",
      "type": "ID",
      "readonly": 3,
      "options": null
    },
    "articleId": {
      "name": "articleId",
      "type": "ID",
      "readonly": false,
      "options": null
    },
    "position": {
      "name": "position",
      "type": "INT",
      "readonly": false,
      "options": null
    },
    "title": {
      "name": "title",
      "type": "STRING",
      "readonly": false,
      "options": null
    },
    "lead": {
      "name": "lead",
      "type": "STRING",
      "readonly": false,
      "options": null
    },
    "status": {
      "name": "status",
      "type": "BOOL",
      "readonly": false,
      "options": null
    },
    "created": {
      "name": "created",
      "type": "DATETIME",
      "readonly": false,
      "options": null
    },
    "preserveImage": {
      "name": "preserveImage",
      "type": "BOOL",
      "readonly": false,
      "options": null
    }
  },
  "attachments": {
    "image": {
      "name": "image",
      "extensions": ["jpg", "png", "gif"],
      "maxFileCount": 1,
      "maxFileSize": 0,
      "meta": null
    }
  },
  "relations": {
    "name": "article",
    "descriptor": {
      "ghost": "Application\\Ghost\\Article",
      "field": "articleId"
    },
    "type": "belongsTo"
  }
};
export default indexFeature;